import { Box, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';

export interface IProcessStepProps {
  title: string;
  description: string;
  width?: number;
}

export const ProcessStep = ({ title, description, width = 880 }: IProcessStepProps) => {
  return (
    <Box width={width}>
      <Text fontSize={20} bold color={Colors.primary_500} marginBottom={16}>
        {title}
      </Text>
      <Text fontSize={16}>{description}</Text>
    </Box>
  );
};
